import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";
import { impersonation } from "@/lib/api";

export default function ImpersonationRibbon({ onChange }) {
  const [info, setInfo] = useState(impersonation.current());
  const navigate = useNavigate();

  useEffect(() => {
    const sync = () => setInfo(impersonation.current());
    window.addEventListener("rimmoget:impersonation", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("rimmoget:impersonation", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  if (!info.id) return null;

  const stop = () => {
    impersonation.stop();
    setInfo({ id: "", name: "" });
    if (onChange) onChange();
    navigate("/dev");
  };

  return (
    <div
      className="w-full bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 border-b-2 border-amber-600 text-amber-950 shadow-md shadow-amber-900/10"
      data-testid="impersonation-ribbon"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-7 h-7 rounded-md bg-amber-950/15 flex items-center justify-center shrink-0">
            <ShieldAlert className="w-4 h-4 text-amber-950" strokeWidth={2} />
          </div>
          <div className="text-xs sm:text-sm font-medium min-w-0">
            <span className="text-[10px] uppercase tracking-[0.18em] font-bold mr-2 px-1.5 py-0.5 rounded bg-amber-950/15">
              DEV · Mode société
            </span>
            <span className="hidden sm:inline">
              Vous êtes connecté en tant que :
            </span>
            <span className="font-bold ml-1.5" data-testid="impersonation-society-name">
              {info.name || "Société"}
            </span>
          </div>
        </div>
        <button
          onClick={stop}
          data-testid="btn-stop-impersonation"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-amber-950 text-amber-100 hover:bg-amber-900 transition-colors text-xs font-semibold self-end sm:self-auto shrink-0"
        >
          <X className="w-3.5 h-3.5" />
          Quitter
        </button>
      </div>
    </div>
  );
}
